import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type SopUpdatedProps = BaseNotificationItemProps & {
  name: string
  description: string
  type: 'sop-updated'
}

export function SopUpdated({ name, description, ...props }: SopUpdatedProps) {
  return (
    <NotificationItem
      {...props}
      title='SOP Updated'
      subTitle={name}
      descriptionAddon={
        <p className='line-clamp-1 text-left text-sm text-gray-500'>
          {`The Update "${description}" is now live.`}
        </p>
      }
    />
  )
}
